module.exports = __webpack_public_path__ + "static/media/mastercardIcon.1921fa34.svg";